/** Calendar labels only: UTC sample dates never change booking timestamp semantics. */
export function createDatepickerLocale(locale, today, clear) {
    const language = locale.replace('_', '-');
    const weekdays = (width) => {
        const formatter = new Intl.DateTimeFormat(language, {weekday: width, timeZone: 'UTC'});
        return Array.from({length: 7}, (_, day) => formatter.format(new Date(Date.UTC(2024, 0, 7 + day))));
    };
    const months = (width) => {
        const formatter = new Intl.DateTimeFormat(language, {month: width, timeZone: 'UTC'});
        return Array.from({length: 12}, (_, month) => formatter.format(new Date(Date.UTC(2024, month, 1))));
    };
    return {
        days: weekdays('long'),
        daysShort: weekdays('short'),
        daysMin: weekdays('short'),
        months: months('long'),
        monthsShort: months('short'),
        today,
        clear,
        weekStart: 1,
    };
}
